<div class="split-button">
	<stages-button
		*ngIf="items && items.length > 0"
		[buttonCSS]="'button sm'"
		[buttonTranslateParams]="items[0].nameParam ? { ARG0: items[0].nameParam | translate } : { ARG0: '' }"
		[title]="items[0].name"
		(clicked)="items[0].on()"
	></stages-button>
	<stages-menu
		*ngIf="items && items.length > 1"
		[menuId]="'splitbutton-menu'"
		[noCollapse]="true"
		[items]="items.slice(1)"
		class="action"
		[openTo]="'bottom dropdown split-button'"
		[iconClasses]="'ico ico-chevron-down'"
		[isToolbarDropdown]="true"
	>
	</stages-menu>
</div>
